import httpCommonClients from "../http-common";
import { EnterpriseEndpoint } from "../utils/api-url";
import { AxiosError } from "axios";
import { PendoResponse } from "../models/PendoResponse";
import { appInsights } from "../config/app-insights";
import { TokenErrorResponse } from "../models/api/types/AdminApi/TokenErrorResponse";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { StorageKeys } from "../utils/constant";
import ext  from "../utils/extensions";

const getPendo = async (
    email: string
  ): Promise<PendoResponse | undefined> => {
    try {      
      const cachedResponse = await ext.getKey(`${StorageKeys.PendoDetails}-${email}`);

      if (cachedResponse != null) {        
        if (cachedResponse.length > 0) {          
          return JSON.parse(cachedResponse);
        }
      }

      const result = await httpCommonClients.enterpriseClient.post<PendoResponse>(
        EnterpriseEndpoint.GetPendo,
        {"emailAddress":email},
        {}
      );
      if (result.status === 200) {
        await ext.setKey(`${StorageKeys.PendoDetails}-${email}`, JSON.stringify(result.data));
        return result.data;
      }
      else {        
        localStorage.removeItem(`${StorageKeys.PendoDetails}-${email}`);
        throw result?.status;
      }      
    } catch (error: AxiosError | any) {            
      const e: TokenErrorResponse = {
        ErrorCode: error?.response?.data?.errorCode,
        ErrorMessage: error?.response?.data?.errorMessage,
        StatusCode: error?.response?.status
      }
            
      appInsights.trackException({ exception: { message: error, name: `EnterpriseServices/getPendo: Exception` }, severityLevel: SeverityLevel.Error, properties: { UserEmail: email } });
      throw e;      
    }
  };

const EnterpriseServices = {    
    getPendo,
};

export default EnterpriseServices;